import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const OTP_EMAIL_KEY = "FCOTPEmail" as const;

export const otpEmailAtom = atomWithStorage<string | null>(
	OTP_EMAIL_KEY,
	null,
	createJSONStorage(() => sessionStorage),
);
otpEmailAtom.debugLabel = "otpEmailAtom";
